import React from 'react';
import { motion } from 'framer-motion';

const Commitment = () => {
  const points = [
    'Ethical & compassionate approach',
    'Ancient Science of energy healing for body-mind-soul',
    'Customized solutions for individuals and organizations',
    'Consistent wellness partnership',
    'Confidentiality & professionalism',
    'Focus on prevention, along with recovery',
  ];

  return (
    <section id="commitment" className="scroll-mt-24 bg-white px-6 py-20 lg:px-8 lg:py-28">
      <div className="mx-auto max-w-7xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.7 }}
          className="mb-12 text-center lg:mb-16"
        >
          <span className="mb-4 block text-xs font-medium uppercase tracking-[0.3em] text-lotus-deep/80">
            Our Commitment
          </span>
          <h2 className="font-serif text-3xl leading-tight text-lotus-ink sm:text-4xl lg:text-5xl">
            How we show up for you
          </h2>
        </motion.div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {points.map((point, idx) => (
            <motion.div
              key={point}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
              whileHover={{ y: -4 }}
              className="flex items-start gap-4 rounded-2xl border border-lotus-petal bg-white p-6 shadow-sm transition-all duration-300 hover:border-lotus-deep/50 hover:shadow-md"
            >
              <div className="mt-2.5 size-2 shrink-0 rounded-full bg-lotus-deep" />
              <p className="font-serif text-lg leading-snug text-lotus-ink">
                {point}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Commitment;
